/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDeviceCounterResponseElements
 */
export interface ReportForDeviceCounterResponseElements {
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceCounterResponseElements
     */
    date: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeviceCounterResponseElements
     */
    count: number | null;
}

export function ReportForDeviceCounterResponseElementsFromJSON(json: any): ReportForDeviceCounterResponseElements {
    return ReportForDeviceCounterResponseElementsFromJSONTyped(json, false);
}

export function ReportForDeviceCounterResponseElementsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceCounterResponseElements {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': (json['date'] === null ? null : new Date(json['date'])),
        'count': json['count'],
    };
}

export function ReportForDeviceCounterResponseElementsToJSON(value?: ReportForDeviceCounterResponseElements | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': (value.date === null ? null : value.date.toISOString()),
        'count': value.count,
    };
}

